import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const KnowledgeBase = ({ config, onUpdate }) => {
  const handleInputChange = (field, value) => {
    onUpdate({ [field]: value });
  };

  return (
    <div className="space-y-6">
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Database" size={20} className="mr-2 text-primary" />
          Knowledge Base Configuration
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Knowledge Base Results"
            type="number"
            min="1"
            max="20"
            value={config?.kb_hits || 5}
            onChange={(e) => handleInputChange('kb_hits', parseInt(e?.target?.value) || 5)}
            description="Number of relevant documents to consider for responses"
          />

          <div className="flex items-center justify-center bg-muted/50 rounded-lg p-6">
            <div className="text-center">
              <Icon name="Upload" size={32} className="mx-auto text-muted-foreground mb-2" />
              <p className="text-sm text-muted-foreground">
                Knowledge Base Upload
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                Coming Soon
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={16} className="text-blue-600 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-blue-900 mb-1">Knowledge Base Tips</h4>
              <ul className="text-xs text-blue-800 space-y-1">
                <li>• Higher values provide more context but slower responses</li>
                <li>• Recommended range: 3-8 documents for most use cases</li>
                <li>• Start with 5 and adjust based on response quality</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBase;